let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hGXAt"), load("1Y6tF")]).then(() => parcelRequire('b3HrA'));